import { defineComponent as _defineComponent } from 'vue'
import { ITab } from "@/shared";
import { ref, onMounted, computed } from "vue";

// props
interface IProps {
	tabs: ITab[];
	extend?: boolean;
	breakline?: boolean;
}

interface IEmits {
	(e: "change", tab: ITab);
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MultiTabs',
  props: {
    tabs: null,
    extend: { type: Boolean },
    breakline: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
	(e: "change", tab: ITab);
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	tabs: ITab[];
	extend?: boolean;
	breakline?: boolean;
};



// computed
const tabsWithoutRedirect = computed<ITab[]>(() => {
	return props.tabs.filter((el) => !el.redirect);
});
const shouldShowTab = computed<(name: string) => boolean>(() => (name) => {
	return activeTab.value.name === name || activeTab.value.redirect === name;
});

// data
const activeTab = ref<ITab>(getDefaultTab());

// methods
function changeTab(tab: ITab): void {
	activeTab.value = tab;
	emit("change", tab);
}
function getDefaultTab(): ITab {
	if (location.hash) {
		const hash = location.hash.replace("#", "");
		return props.tabs.find(({ name }) => name === hash) ?? props.tabs[0];
	}

	return props.tabs[0];
}

// setup
onMounted(() => {
	changeTab(activeTab.value);
});

// emits


return { __sfc: true,props, tabsWithoutRedirect, shouldShowTab, activeTab, changeTab, getDefaultTab, emit }
}

})